import { Component, Container, HBox, VBox } from "puzzle";
import React from "react";
import TextComponent from "puzzle/components/UI/text_component/TextComponent";

export type DATA = {
  body: string,
  level: string,
  subject: string
};

type PROPS = {
  announcementData?: DATA[],
  firstName: string
};

type STATE = {
  data?: DATA[],
  firstName: string,
};

class AnnouncementDialog extends Component<PROPS, STATE> {

  state: STATE = {
    data: [],
    firstName: ''
  }

  moduleDidMount = () => {
    const { announcementData, firstName } = this.props
    this.setState({ data: announcementData, firstName })
  }

  /**
   * Sets data for AnnouncementDialog
   * @param announcementData
   * @param userName
   */
  setData = (announcementData: DATA[], userName: string) => {
    this.setState({ data: announcementData, firstName: userName })
  }


  renderBody() {
    return (
      <Container
        alignItemsStart
        displayFlex
        flexDirectionColumn
        flex1
        className={'tp-transparent'}>
        <HBox
          displayFlex
          flexDirectionColumn
          alignItemsStart
          justifyContentCenter
          className={'pd-announcement-header'}>
          <span
            className={'tp-font-size-xxl tp-text-semibold'}
          >
            {this.translate('welcomeToPd', { firstName: this.state.firstName, className: 'tp-color-link' })}
          </span>
          <span>
            {this.translate('newsAndInfo')}
          </span>
        </HBox>
        <VBox gap={4} className="k-px-6 tp-100 k-pt-10 k-pb-6">
          {this.state.data?.map((item: DATA) => {
            return (<VBox
              key={item.subject}
              className={'pd-announcement-card tp-100'}
            >
              <TextComponent
                htmlTag={'h1'}
                size={'md'}
                thickness={'semi-bold'}
                className='tp-100 k-d-flex k-align-items-center'
              >
                {item.subject}
              </TextComponent>
              <div
                className={'pd-announcement-text tp-font-size-sm'}
                dangerouslySetInnerHTML={{ __html: item.body }}
              />
            </VBox>)
          })}
        </VBox>
      </Container>
    );
  }
}

export default AnnouncementDialog;

